import { ChangeDetectorRef, Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
	selector: '[auHorizontalScroll]',
	exportAs: 'auHorizontalScroll',
})
export class AuHorizontalScrollDirective {
	private isOverflowLasValue: boolean;

	constructor(
		private elRef: ElementRef,
		private cdRef: ChangeDetectorRef
	) {}

	/**
	 * Host listener is required for update view when windows resized
	 * Even if it's empty
	 * p.s. Ancient magic
	 */
	@HostListener('window:resize')
	onWindowResize() {}

	scrollLeft() {
		this.element.scrollLeft -= 150;
	}

	scrollRight() {
		this.element.scrollLeft += 150;
	}

	private get element(): HTMLElement {
		return this.elRef.nativeElement;
	}

	get isHorizontalOverflow(): boolean {
		const isOverflow = this.element.scrollWidth > this.element.offsetWidth;
		this.noticeAngularThatElRefChanged(isOverflow);

		return this.element.scrollWidth > this.element.offsetWidth;
	}

	get canScrollStart() {
		return this.element.scrollLeft > 0;
	}

	get canScrollEnd() {
		return (
			this.element.scrollLeft + this.element.clientWidth !== this.element.scrollWidth
		);
	}

	private noticeAngularThatElRefChanged(isOverflow: boolean) {
		if (this.isOverflowLasValue !== isOverflow) {
			this.isOverflowLasValue = isOverflow;
			this.cdRef.detectChanges();
		}
	}
}
